module.exports = __webpack_public_path__ + "static/img/1.5e2778d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/honour/1.jpg
// module id = qLKn
// module chunks = 1